/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { MenuItem } from '@mui/material';
import React from 'react';
import { SelectRenderArgs } from '../models/Common';
import { getDeepValue } from './Common';

export const renderSelectItems = (
  {
    items = [],
    valueKey,
    labelKey,
    labelCondition
  }: SelectRenderArgs
) => (items || []).map((i) => {
  const value = valueKey ? getDeepValue(i, valueKey) || i : i;
  return   <MenuItem key={value} value={value}>
    {labelCondition ? labelCondition(i) : (labelKey ? getDeepValue(i, labelKey) || i : i)}
  </MenuItem>;
});

export const renderSelectItemsWithEmpty = (
  args: SelectRenderArgs
) => [
  <MenuItem key="empty" value="" className="text-placeholder">
    No value
  </MenuItem>
].concat(renderSelectItems(args));
